<template>
  <div>
    <div id="mC">
        <div  id="header" >
          <div  id="menuContainerL" title="Home">
              <img id="iconHome"  @click= "btnHome"  src="/dist/logo-header2.png" v-show='showHeader' />
          </div>
          <div  id="menuContainerR" v-show='showHeader' >
              
              <span id="menuPedido" @click= "btnCliente">{{ nombreCliente }}</span> 
              
              <div id="carritoItemsGlobe" v-show='itemsCarrito!=0' @click= "btnCarrito">
                <span id="carritoCantItem"  v-show='itemsCarrito!=0' style="color:#4969B2; font-weight: 500; font-size: 12px"  >{{itemsCarrito}}</span>
              </div>
              <img  id="iconCarrito" class="icon" @click= "btnCarrito"  src="/dist/carrito.svg" />


              <div class="dropdown" @mouseover='showDropUsuario' @mouseleave='hideDropUsuario'>
                <span id="usuario">{{nombreUsuario}}</span>
                <div id="avatarGlobe">
                    <span id="avatarChar" style="color:#4969B2; font-weight: 700; font-size: 18px ">{{letraNombreUsuario}}</span>
                </div>
                <div  class="dropdown-content-b"  v-show='dropUsuario' >
                    <router-link :to="{name: 'configuracion'}">Cambiar contraseña</router-link>
                    <div class="separator-menu"></div>
                    <router-link :to="ctacte">Cuenta Corriente</router-link>
                    <div class="separator-menu"></div>
                    <a href="#cerrar" @click="cerrarSesion">Cerrar sesión</a>
                </div>
              </div>

          </div>
        </div>
    </div>
    <div  class="separator" >  </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "sales-header",

  data() {
    return {
      dropPedidos: false,
      dropUsuario: false,
      dropGiras: false
    };
  },

  computed: {

    ctacte () 
    {
      let route = {
        name: 'ctacte'
      }

      if (this.$store.state.user.esEmpleado) 
      {
        route.name = 'clientes'
        route.query = { redirect: 'ctacte' }
      }

      return route
    },

    showHeader()
    {
      if (this.$route.name == 'clientes') 
      {
        return false
      }
      else
      {
        return true
      }
    }, 


    itemsCarrito() 
    {
      return this.$store.state.pedido.carrito.length;
    },

    nombreUsuario() 
    {
      if (this.$store.state.user.usuario.EsEmpleado)
      {
        return this.$store.state.user.usuario.EmpleadoNombre;
      } 
      else
      {
        return this.$store.state.user.usuario.ClienteNombre;
      }  
    },

    letraNombreUsuario() 
    {
      if (this.$store.state.user.usuario.EsEmpleado)
      {
        return this.$store.state.user.usuario.EmpleadoNombre.charAt(0);
      } 
      else
      {
        return this.$store.state.user.usuario.ClienteNombre.charAt(0);
      }  
    },

    nombreCliente() 
    {
      if ((this.$store.state.user.usuario.EsEmpleado) && (this.$store.state.user.cliente != null))
      {
        return "Cliente: "+this.$store.state.user.cliente.Nombre;  
      } 
      else
      {
        return "";
      }  
    }

  },

  methods: {
  
    btnCarrito() 
    {
      if (this.$store.state.user.cliente != null)
      {
        if (this.itemsCarrito > 0) 
        {
          this.$router.push({ name: "pedido" });
        }
        else 
        {
          this.$store.commit("pedido/setBorradorId", 0);
          this.$router.push({ name: "realizarPedido" });
        }
      }
      else
      {
        this.$router.push({ name: "clientes" })
      }
    },

    btnHome() 
    {
      this.$router.push({ name: "home" });
    },

    btnCliente() {
      console.log('aaaaaaaa')
      this.$router.push({ name: "clientes" });
    },

    showGiras () {
      this.dropGiras = true;
    },

    hideGiras () {
      this.dropGiras = false;
    },

    showDropPedidos() {
      this.dropPedidos = true;
    },

    hideDropPedidos() {
      this.dropPedidos = false;
    },

    showDropUsuario() {
      this.dropUsuario = true;
    },

    hideDropUsuario() {
      this.dropUsuario = false;
    },

    cerrarSesion() {
      var token =  this.$store.state.user.usuario.Token  
     

      axios
        .put(
          "/WebSalesLogin",
          {},
          {
            headers: {
              Token: token,
              ClientSecret: process.env.CLIENT_SECRET
            }
          }
        )
        .then(
          response => {
            this.$store.commit("user/deleteUser");
            this.$store.commit("user/deleteCliente");
            this.$store.commit("pedido/delete");
            this.$access("any"); 
            this.$router.push({ name: "login" });
          },
          error => {
            this.$store.commit("user/deleteUser");
            this.$store.commit("user/deleteCliente");
            this.$store.commit("pedido/delete");
            this.$access("any");
            this.$router.push({ name: "login" });
          }
        );
    }
  }
};
</script>


<style scoped>
#menuPedido a {
  color: white;
  text-decoration: none
}

.dropdown {
  display: flex;
  align-items: center;
  height: 40px
}

.dropdown-content:before {
  content: "";
  position: absolute;
  right: 120px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #ffffff transparent;
  z-index: 9999;
}

.dropdown-content {
  top: 40px;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a:hover {
  cursor: pointer;
  color: #000000;
}

.dropdown-content a {
  color: #555555;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 12px;
  font-weight: 400;
}

/* ------------------------------------------------------ */

.dropdown-content-b:before {
  content: "";
  position: absolute;
  right: 80px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #ffffff transparent;
  z-index: 9999;
}

.dropdown-content-b {
  /* margin-top: 78px; */
  margin-top: 152px;
  margin-left: 30px;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content-b a:hover {
  cursor: pointer;
  color: #000000;
}

.dropdown-content-b a {
  color: #555555;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 12px;
  font-weight: 400;
}

#mC {
  background-color: #005a9f;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
}

#header {
  width: 700px;
  height: 40px;
  background-color: #005a9f;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#menuContainerR {
  width: 450px;
  font-size: 10px;
  color: #ffffff;
  background-color: #005a9f;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

#menuContainerL {
  width: 250px;
  height: 40px;
  background-color: #005a9f;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

#menuPedido {
  display: flex;
  height: 40px;
  align-items: center;
  padding-right: 40px;
  padding-left: 0px;
  vertical-align: middle;
  font-size: 12px;
}

#usuario {
  padding-right: 10px;
  padding-left: 40px;
  vertical-align: middle;
  font-size: 12px;
}

#iconHome {
  height: 25px;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: #136aaa;
}

.separator-menu {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
}

#carritoItemsGlobe {
  width: 17px;
  height: 17px;
  background: #ffffaa;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

#avatarGlobe {
  width: 28px;
  height: 28px;
  background: #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

#iconCarrito:hover {
  cursor: pointer;
}
#carritoItemsGlobe:hover {
  cursor: pointer;
}
#usuario:hover {
  cursor: pointer;
}
#avatarGlobe:hover {
  cursor: pointer;
}
#iconHome:hover {
  cursor: pointer;
}
#menuPedido:hover {
  cursor: pointer;
}

.menu:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/header.vue